<ion-list class="ion-margin-horizontal-negative ion-padding-top-0">
  <ion-item-group>
    <ion-item-divider sticky>
      <ion-label>Empresas</ion-label>
    </ion-item-divider>

    @for (company of companies(); track company.id) {
      <ion-item>
        <ion-grid>
          <ion-row>
            <ion-col
              class="ion-align-self-center"
              size="12"
              size-lg="3"
            >
              <p>
                <strong>{{ company.companyName }}</strong>
                ({{ company.taxId }})
              </p>
            </ion-col>
            <ion-col
              class="ion-align-self-center"
              size="12"
              size-lg="3"
            >
              <p>{{ company.contactFirstName }} {{ company.contactLastName }}</p>
            </ion-col>
            <ion-col
              class="ion-align-self-center"
              size="12"
              size-lg="3"
            >
              <p>{{ company.contactEmail }}</p>
            </ion-col>
            <ion-col
              class="ion-text-end ion-align-self-center"
              size="12"
              size-lg="3"
            >
              @if (company.isCarrier) {
                <span class="tag">Transportista</span>
              }
              @if (company.isShipper) {
                <span class="tag">Cargador</span>
              }
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>
    } @empty {
      <ion-item>
        <ion-label>
          <p class="fs-sm ion-text-center">No hay empresas guardadas</p>
        </ion-label>
      </ion-item>
    }
  </ion-item-group>
</ion-list>
